import { useState, useEffect } from "react";
import { DEFAULT_AUTHENTICATED_STRING, DEFAULT_UNAUTHENTICATED_STRING } from "../constants";

export const useSessionData = () => {
    const [sessionData, setSessionData] = useState(null);
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        const getSessionData = async () => {
            try {
                const response = await fetch("/api/auth/session", {
                    cache: "no-store",
                });
                const data = await response.json();
                setSessionData(data);

                if (data && Object.keys(data).length !== 0) {
                    setStatus(DEFAULT_AUTHENTICATED_STRING);
                } else {
                    setStatus(DEFAULT_UNAUTHENTICATED_STRING);
                }
            } catch (error) {
                setStatus(DEFAULT_UNAUTHENTICATED_STRING);
            }
        };

        getSessionData();
    }, []);

    return { sessionData, status };
};
